(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('.blog-post-comment__reply');
    if (!button) return;

    const messageField = document.getElementById(button.dataset.replyTarget);
    if (!messageField) return;

    const replyPrefix = `@${button.dataset.replyAuthor} `;
    const currentMessage = messageField.value.trimStart();

    if (!currentMessage.startsWith(replyPrefix)) {
      messageField.value = `${replyPrefix}${currentMessage}`;
    }

    const nameField = document.getElementById(button.dataset.replyNameTarget);
    if (nameField && !nameField.value.trim()) {
      nameField.value = 'MYOSTRUX';
    }

    messageField.focus();
    messageField.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
